import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

export function useAppTour() {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#app-header',
        popover: {
          title: 'Application Header',
          description: 'Access quick navigation, search, notifications, and your user profile from here.',
          side: 'bottom'
        }
      },
      {
        element: '.search-box',
        popover: {
          title: 'Global Search',
          description: 'Quickly find features, records, or documentation using the search bar. Press ⌘K to focus.',
          side: 'bottom'
        }
      },
      {
        element: '#app-sidebar',
        popover: {
          title: 'Navigation Menu',
          description: 'Access all application features and modules from this menu. You can collapse it for more space.',
          side: 'right'
        }
      },
      {
        element: '#category-buttons',
        popover: {
          title: 'Quick Categories',
          description: 'Switch between different sections like Sales, Inventory, and Finance.',
          side: 'top'
        }
      },
      {
        element: '#notifications-button',
        popover: {
          title: 'Notifications',
          description: 'Stay updated with important alerts and updates about your business.',
          side: 'left'
        }
      },
      {
        element: '#user-menu',
        popover: {
          title: 'User Menu',
          description: 'Access your profile, settings, and other account-related options.',
          side: 'left'
        }
      }
    ]
  })

  const startTour = () => {
    driverObj.drive()
  }

  const initTour = () => {
    // Check if this is the first time loading the company
    const hasSeenTour = localStorage.getItem('hasSeenAppTour')
    if (!hasSeenTour) {
      startTour()
      localStorage.setItem('hasSeenAppTour', 'true')
    }
  }

  return {
    startTour,
    initTour
  }
}